import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { UpdateNeededComponent } from '@app/shared/components/update-needed.component';
import { AppUpdateNeededComponent } from '@app/shared/components/app-update-needed.component';
import { X_HOHR_NEW_APP_AVAILABLE, X_HOHR_UPDATE_NEEDED } from '../core.constants';

const UPDATE_NEEDED_MODAL_ID = 'update-needed';
const APP_UPDATE_NEEDED_MODAL_ID = 'app-update-needed';

export const forcedUpdateInterceptor: HttpInterceptorFn = (
    httpRequest: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const modalController = inject(ModalController);
    return next(httpRequest).pipe(
        tap(async (event) => {
            if (!(event instanceof HttpResponse)) return;

            const updateNeeded = event.headers.get(X_HOHR_UPDATE_NEEDED);
            const newApp = event.headers.get(X_HOHR_NEW_APP_AVAILABLE);

            if (updateNeeded !== 'true' && newApp !== 'true') return;

            if (newApp === 'true') {
                const topModal = await modalController.getTop();
                if (topModal?.id === APP_UPDATE_NEEDED_MODAL_ID) return;

                const modal = await modalController.create({
                    component: AppUpdateNeededComponent,
                    canDismiss: false,
                    id: APP_UPDATE_NEEDED_MODAL_ID
                });
                await modal.present();
                return;
            }

            if (updateNeeded === 'true') {
                const topModal = await modalController.getTop();
                if (topModal?.id === UPDATE_NEEDED_MODAL_ID) return;

                const modal = await modalController.create({
                    component: UpdateNeededComponent,
                    canDismiss: false,
                    id: UPDATE_NEEDED_MODAL_ID,
                });
                await modal.present();
            }
        })
    );
};